import * as types from "../types/rlab-types";

const defaultState = {
  generating: false,
  variants: {}
};

const reducer = (state = defaultState, action) => {
  switch (action.type) {
    case types.GENERATE_VARIANTS_RESET:
      return Object.assign({}, state, {
        generating: false
      });
    case types.GENERATE_VARIANTS_PENDING:
      return Object.assign({}, state, {
        generating: true
      });
    case types.GENERATE_VARIANTS_FAILURE:
      return Object.assign({}, state, {
        generating: false
      });
    case types.GENERATE_VARIANTS_SUCCESS:
      const variants = Object.assign({}, state.variants, action.res);
      return Object.assign({}, state, {
        generating: false,
        variants
      });
    default:
      return state;
  }
};

export default reducer;
